<template>
  <div class="container m-b-2">
    <MainTitle title="Impactos del glifosato" />

    <!-- <h2 class="subtitulo">Espacios de uso de glifosato<span class="a11y-solo-lectura">.</span></h2> -->
    <MapaPrincipalesCultivos class="m-y" />
    <MapaUsoHerbicidas class="m-y" />
    <MapaRendiemeintoCultivos class="m-y" />

    <!-- <h2 class="subtitulo m-t-4">Expediente<span class="a11y-solo-lectura">.</span></h2> -->

    <div class="grid-descargas m-y-1 m-b-2-sm m-b-0-md">
      <LinkPDF
        class="m-b-1-sm m-b-0-md"
        link="descargables/impactos/glifosato.pdf"
        descripcion="Expediente científico sobre el glifosato y los cultivos GM"
        nombre="Expediente Científico"
        imagen_lap="portadas_version_escritorio/expediente_cientifico_glifosato_web.png"
        imagen_cel="portadas_version_movil/expediente_cientifico_glifosato_movil.png"
      />
      <LinkPDF
        class="m-b-1-sm m-b-0-md"
        link="descargables/impactos/la_indisoluble_relacion_del_glifosato_con_los_transgenico.pdf"
        descripcion="La indisoluble relación del glifosato y los transgénicos"
        nombre="Infografía"
        imagen_lap="portadas_version_escritorio/exposicion_humana_glifosato_web.png"
        imagen_cel="portadas_version_movil/exposicion_humana_glifosato_movil.png"
      />
    </div>

  </div>
</template>

<script>
import MainTitle from '@/components/MainTitle.vue'
import MapaPrincipalesCultivos from "@/components/mapas/MapaPrincipalesCultivos.vue"
import MapaUsoHerbicidas from '@/components/mapas/MapaUsoHerbicidas.vue'
import MapaRendiemeintoCultivos from '@/components/mapas/MapaRendiemeintoCultivos.vue'
import LinkPDF from "@/components/impacto/LinkPDF.vue";

export default {
  name: 'Repositorio',
  components: {
    LinkPDF,
    MainTitle,
    MapaPrincipalesCultivos,
    MapaUsoHerbicidas,
    MapaRendiemeintoCultivos,
  },
  computed: {
    isA11yContrast() {
      return this.$store.getters.isA11yContrast
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
}
</script>
<style lang="scss" scoped>
.container {
  .grid-descargas {
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 16px;
      row-gap: 32px;
    }
  }
}
</style>